import { useMutation, useQueryClient } from 'react-query';
import { BookingProps } from 'services/hooks/booking-service';

const useSaveBooking = ({
  createQuery,
  updateQuery,
  queryName,
  onSuccess,
  onError
}: {
  createQuery: any;
  updateQuery: any;
  queryName: string;
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}) => {
  const queryClient = useQueryClient();
  const saveBookingMutation = useMutation(
    async ({ uuid, ...restBookingProperties }: BookingProps): Promise<string> => {
      if (uuid) {
        try {
          const data = await updateQuery(uuid, restBookingProperties);
          return data;
        } catch (error) {
          throw error;
        }
      } else {
        try {
          const data = await createQuery(restBookingProperties);
          return data;
        } catch (error) {
          throw error;
        }
      }
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(queryName);
        queryClient.removeQueries('booking');

        if (onSuccess) {
          onSuccess();
        }
      },
      onError: async (error: Error) => {
        if (onError) {
          onError(error);
        }
      }
    }
  );

  return saveBookingMutation;
};

export default useSaveBooking;
